import { useEffect, useRef } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import { motion } from 'framer-motion'
import { NeuroIQLogo } from '../components/NeuroIQLogo'

export default function AuthCallbackPage() {
  const [searchParams] = useSearchParams()
  const hasRedirected = useRef(false)

  useEffect(() => {
    if (hasRedirected.current) return
    hasRedirected.current = true

    const code = searchParams.get('code')
    const state = searchParams.get('state')
    const providerKey = sessionStorage.getItem('idp_provider_key')

    if (!code || !state || !providerKey) {
      window.location.replace('/login?error=callback_failed')
      return
    }

    sessionStorage.removeItem('idp_provider_key')

    const callbackUrl = `/auth/callback/${providerKey}?code=${encodeURIComponent(code)}&state=${encodeURIComponent(state)}`
    window.location.href = callbackUrl
  }, [searchParams])

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-slate-50">
      <motion.div 
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="flex flex-col items-center gap-6 rounded-2xl bg-white p-12 shadow-xl shadow-slate-200/50"
      >
        <NeuroIQLogo />
        <div className="flex flex-col items-center gap-4 mt-4">
          <Loader2 className="h-8 w-8 animate-spin text-brand-600" />
          <p className="text-sm font-medium text-slate-500">Completing secure sign in...</p>
        </div>
      </motion.div>
    </div>
  )
}
